module.exports = __webpack_public_path__ + "static/logo-extended-bdddd2d2371a407dc8cbb11272455008.svg";